var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Link',{attrs:{"lines":_vm.lines}}),_vm._l((_vm.blocks),function(block){return _c('Block',_vm._b({key:block.id,ref:"blocks",refInFor:true,attrs:{"options":_vm.optionsForChild},on:{"select":function($event){return _vm.blockSelect(block)},"openModal":function($event){return _vm.openModal($event)}}},'Block',block,false,true))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }